import React, { createRef } from 'react';
import { observer, inject } from 'mobx-react';
import { withTranslation } from 'react-i18next';
import style from './style.module.css';
import Modal from 'react-modal';
import APILoader from '../../APILoader';
import MakeOrderErrorModal from "../MakeOrderErrorModal";
import ThanksModal from '../../ThanksModal';
//import Geocode from 'react-geocode';
import { getDistance } from 'geolib';
import {
    withScriptjs,
    withGoogleMap,
    GoogleMap,
    Marker,
} from "react-google-maps";
import PostageModal from './PostageModal';
import { Media } from 'react-bootstrap';

//Geocode.setApiKey(process.env.REACT_APP_GOOGLE_MAPS_API_KEY);
//Geocode.setLanguage('he')

@inject(store => {
    const { myShopApiStore, ifaceMngr } = store;
    return { myShopApiStore, ifaceMngr };
})

@observer
class MapModal extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {  
                        distOutOfRange: false,
                        postageModalIsOpen: false,
                        apiLoaderIsOpen: false,
                        makeOrderErrorModalIsOpen: false,
                        makeOrderErrorModalErrorCode: '',
                        makeOrderErrorModalErrorMessage: '',
                        isMobile: window.innerWidth <= 850,
                    }
        
        this.modalStyle = {
            content : {
                backgroundColor: 'unset',
                top: '50%',
                left: '51%',
                right: 'auto',
                bottom: 'auto',
                marginRight: '-50%',
                transform: 'translate(-50%, -50%)',
                borderRadius: '20px',
                width:  this.state.isMobile ? '100%' : '65%',
                height: '90%',
                maxHeight: '100%',
                border: 'unset',
                overflow: 'auto',
                
            },
            overlay: {
                backgroundColor: "rgb(0, 0, 0, 0.87)",
                zIndex: 5,
            }
        }
    }

    updateIsMobile = () => {
        this.setState({ isMobile: window.innerWidth <= 850 });
      }

    componentDidMount() {
        window.addEventListener('resize', this.updateIsMobile); 
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateIsMobile);
    }

    getAddress = () => {
        const { streetName, streetNumber, city } = this.props.myShopApiStore.userParams;
        return `${streetName} ${streetNumber}, ${city} `;
    }

    onMarkerDargEnd = async (event) => {
        const newLat = event.latLng.lat();
        const newLng = event.latLng.lng();
        
        const { setDeliveryLatLng, setUserParams} = this.props.myShopApiStore;        

        /*
        await Geocode.fromLatLng(newLat, newLng)
        .then(response => {
            if(response.results){
                if(response.results.length){
                    setDeliveryLatLng({ lat: newLat, lng: newLng })
                    setUserParams('streetNumber', response.results[0].address_components[0].long_name)
                    setUserParams('streetName', response.results[0].address_components[1].long_name)
                    setUserParams('city', response.results[0].address_components[2].long_name)
                }
            } 
        })
        .catch(err => {
            setDeliveryLatLng({ lat: newLat, lng: newLng });
            console.log("ERROR::",err)
        })
        */

        setDeliveryLatLng({ lat: newLat, lng: newLng });
        
    }

    getLat = () => {
        const { getDeliveryLatLng } = this.props.myShopApiStore;
        return getDeliveryLatLng() ? getDeliveryLatLng().lat : 32.085300;
    }

    getLng = () => {
        const { getDeliveryLatLng } = this.props.myShopApiStore;
        return getDeliveryLatLng() ? getDeliveryLatLng().lng : 34.781769;
    }

    MapWithAMarker = withScriptjs(withGoogleMap(props =>
        
        <GoogleMap
        defaultZoom={16}
        defaultCenter={{ lat: this.getLat(), lng: this.getLng() }}
        >
        <Marker
            position={{ lat: this.getLat(), lng: this.getLng() }}
            draggable={true}
            onDragEnd={this.onMarkerDargEnd}
        />

        </GoogleMap>
        
    ));

    handleUpdateAddressClick = () => {
        this.calcPostage();
        // this.setState({ distance });
        this.openPostageModal();
    }

    calcPostage = async () => {
        const { getShopLatLng, shop, getDeliveryLatLng, getDeliveryPriceResp,
                setDeliveryCost, setDeliveryLatLng, setOrderData } = this.props.myShopApiStore;
        const deliveryZonesAmount = shop.deliveryZones ? shop.deliveryZones.length : 0;

        let distance = 0;

        if(!getDeliveryLatLng() || !getShopLatLng()){ //handle fetching error of shop/user locations! (addrs -> lat/lng)
            this.setState({distOutOfRange: true});
        }
        else{
            const {shopLat, shopLng} = getShopLatLng()
            const { lat, lng } = getDeliveryLatLng();
    
            //checks distance in meters
            distance = getDistance(
                                { latitude: shopLat, longitude: shopLng },
                                { latitude: lat, longitude: lng }
                            );
            
            // convert meters to km
            distance /= 1000;
    
            //calc delivery cost
            if(shop.isAreaDelivery){ // for new interface
                this.setState({apiLoaderIsOpen: true});
                const resp = await getDeliveryPriceResp();
                console.log("resp>>>>", resp)
                this.setState({apiLoaderIsOpen: false});
                if (resp.data.errorCode === "0" && (resp.data.data && resp.data.data.deliveryCost !== null)) {
                    setDeliveryCost(resp.data.data.deliveryCost ? resp.data.data.deliveryCost : 0);
                    // setDeliveryLatLng({ lat, lng });
                    setDeliveryLatLng({ lat: resp.data.data[0], lng: resp.data.data[1] });
                    this.state.distOutOfRange && this.setState({distOutOfRange: false})
                    
                    //checks distance in meters
                    distance = getDistance(
                        { latitude: shopLat, longitude: shopLng },
                        { latitude: lat, longitude: lng }
                    );
    
                    // convert meters to km
                    distance /= 1000;

                    console.log("distance:",distance)
                }
                else{
                    !this.state.distOutOfRange && this.setState({distOutOfRange: true})
                    distance = 0;
                }
            }
            else{
                for(let i=0; i<deliveryZonesAmount ; i++){
                    const { deliveryCost, from, to}  = shop.deliveryZones[i];
                    if(distance >= from && distance < to){
                        setDeliveryCost(deliveryCost);
                        setDeliveryLatLng({ lat, lng });
                        if(this.state.distOutOfRange){
                            this.setState({distOutOfRange: false})
                        }
                        break;
                    }
                }
            }
    
            console.log("deliveryZonesAmount:",deliveryZonesAmount)
            
            //distance out of range
            if(deliveryZonesAmount && !shop.isAreaDelivery){ //  "&& !shop.isAreaDelivery"  is ADDED!!!
                if(shop.deliveryZones[shop.deliveryZones.length-1].to <= distance){
                    this.setState({distOutOfRange: true}); 
                    distance = 0;
                }
            }
            
            //calc delivery cost for 'katif' shop (old interface)
            if(!deliveryZonesAmount && typeof shop.isAreaDelivery == 'undefined'){
                if(distance >= 0 && distance < shop.deliveryRadius){
                    setDeliveryCost(shop.deliveryCost);
                    setDeliveryLatLng({ lat, lng });
                    
                    if(this.state.distOutOfRange){
                        this.setState({distOutOfRange: false})
                    }
                }
                else{
                    this.setState({distOutOfRange: true})
                    distance = 0;
                }
            }
        }

        setOrderData('distance', Math.floor(distance));
    }

    openPostageModal = () => {
        this.setState({postageModalIsOpen: true})
    }

    closePostageModal = () => {
        this.setState({postageModalIsOpen: false})
    }

    // openThanksModal = () => {
    //     this.setState({thanksModalIsOpen: true})
    // }

    // closeThanksModal = () => {
    //     this.setState({thanksModalIsOpen: false})
    //     this.props.closeModal();
    // }
    
    openAPILoader = () => {
        this.setState({apiLoaderIsOpen: true})
    }

    closeAPILoader = () => {
        this.setState({apiLoaderIsOpen: false})
    }

    closeMakeOrderErrorModal = () => {
        this.setState({makeOrderErrorModalIsOpen: false})
    }

    openMakeOrderErrorModal = () => {
        this.setState({makeOrderErrorModalIsOpen: true})
    }

    setMakeOrderErrorModalParams = (makeOrderErrorModalErrorCode, makeOrderErrorModalErrorMessage) => {
        this.setState({
            makeOrderErrorModalErrorCode: makeOrderErrorModalErrorCode,
            makeOrderErrorModalErrorMessage: makeOrderErrorModalErrorMessage
        })
    }

    render() {
        const { modalIsOpen, closeModal, t } = this.props;
        const { orderData, userParams, mainColor, my_env } = this.props.myShopApiStore;
        return (
            <Modal style={this.modalStyle} isOpen={modalIsOpen}>
                <div className={style.TopContent}>
                    <div className={style.Title}>
                        <p>
                            {t('Please check your delivery location. If the location on the map is inaccurate, please move the pin to the exact location and press Confirm location.')}
                        </p>
                    </div>
                    <div className={style.Address}>
                        <span>{userParams.streetName ? this.getAddress() : t("notFoundResults")}</span>
                    </div>
                </div>
                <this.MapWithAMarker
                    googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&v=3.exp&libraries=geometry,drawing,places`}
                    loadingElement={<div style={{ height: '100%' }} />}
                    containerElement={<div style={{ height: '60%' }} />}
                    mapElement={<div style={{ height: '100%',borderRadius: '9px' }} />}
                />
                <div className={style.BottomContent}>
                    <div className={style.AddressUpdateBtn}
                         onClick={this.state.apiLoaderIsOpen ? null : this.handleUpdateAddressClick}
                         style={{backgroundColor: mainColor, opacity: this.state.apiLoaderIsOpen ? ".4" : null}}>
                        <span>{t('Confirm location')}</span>
                    </div>
                    <div className={style.BackBtn} onClick={closeModal}>
                        <span>{t('back')}</span>
                    </div>
                </div>
                
                <div>
                    {
                        !this.state.apiLoaderIsOpen 
                        ?
                            <PostageModal modalIsOpen={this.state.postageModalIsOpen}
                                            closeModal={this.closePostageModal}
                                            closeMapModal={closeModal}
                                            address={this.getAddress()}
                                            distOutOfRange={this.state.distOutOfRange}
                                            nextStep={this.props.nextStep}
                                            openAPILoader={this.openAPILoader}
                                            closeAPILoader={this.closeAPILoader}
                                            openMakeOrderErrorModal={this.openMakeOrderErrorModal}
                                            setMakeOrderErrorModalParams={this.setMakeOrderErrorModalParams}
                                            openThanksModal={this.props.openThanksModal} 
                                            closeThanksModal={this.props.closeThanksModal}
                                            thanksModalIsOpen={this.props.thanksModalIsOpen}    
                            />
                        :
                            null
                    }
                </div>
                <div className={style.Modals}>
                    <APILoader modalIsOpen={this.state.apiLoaderIsOpen} />
                    <MakeOrderErrorModal 
                        modalGoBack={true}
                        closeModal={this.closeMakeOrderErrorModal} 
                        modalIsOpen={this.state.makeOrderErrorModalIsOpen} 
                        makeOrderErrorModalErrorCode={this.state.makeOrderErrorModalErrorCode} 
                        makeOrderErrorModalErrorMessage={this.state.makeOrderErrorModalErrorMessage}
                        openBasket={this.props.openBasket}
                    />
                </div>
            </Modal>
        )
    }
}

export default withTranslation()(MapModal);